import { Box } from "@mui/system";
import React from "react";
import { ButtonGroup } from "react-bootstrap";
import Button from "../buttons/Buttons";
import styles from "./tabButtonGroup.module.scss";
import PropTypes from "prop-types";

const TabButtonGroup = (props) => {
  const {
    buttonList = [],
    handleTabClick,
    withIcon,
    showCountSection,
    selectedTab = 0,
  } = props;
  return (
    <Box
      className={styles.tabButtonGroupWrapper}
      data-testid="tab-button-group"
    >
      <ButtonGroup
        variant="contained"
        aria-label="outlined primary button group"
        className={styles.btnWrapper}
      >
        {buttonList?.map((buttonItem, index) => (
          <Box
            key={buttonItem?.title}
            className={`${
              buttonList.length === 1
                ? styles.singleItemWrapper
                : styles.tabItemWrapper
            }`}
          >
            <Button
              title={buttonItem.title}
              iconStyle={`${buttonItem.iconStyle}`}
              buttonType={`muibtn-tab ${buttonItem.Styles}`}
              withIcon={withIcon}
              handleClick={() => handleTabClick(index)}
              showCountSection={showCountSection}
              count={buttonItem.count}
              classList={selectedTab === index ? "selectedtab" : "defaultTab"}
            />
          </Box>
        ))}
      </ButtonGroup>
    </Box>
  );
};
export default TabButtonGroup;

TabButtonGroup.propTypes = {
  buttonList: PropTypes.any,
  handleTabClick: PropTypes.any,
  withIcon: PropTypes.any,
  showCountSection: PropTypes.any,
  selectedTab: PropTypes.any,
};
